import { Network as TabIconNetwork } from "lucide-react";
import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { VBox } from "@ui/box/Box";
import { CreditCard, Key, Settings as SettingsIcon, Undo2 } from "lucide-react";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { Sessions } from "src/view/forms/Sessions";
import { MerchantChannels } from "src/view/conponents/list/MerchantChannels";
import { checkFeature, TAvailableFeatures } from "src/Featuresmap";
import { Credentials } from "src/view/forms/Credentials";
import { Settings } from "src/view/forms/Settings";
import { useHasPermission } from "src/hooks/tools";
import { ClientChargebacks } from "../clientPage/subpages/ClientChargebacks";

//!TODO: rename to Merchant Page?
export const ClientGroupPage = () => {
	useLocale();
	// TODO - move to manager
	const router = useRouter();

	const clientId = parseInt(router.currentParams.cid ?? 0, 10);
	const canManageMerchant = useHasPermission("merchants.manage");

	const [groupReq, _1, _2, busy] = GD.REQ_GROUP.useRequest(undefined, {
		groupID: parseInt(router.currentParams.mid ?? 0, 10),
		clientID: clientId,
	});

	const merchant = groupReq?.data ?? null;

	return (
		<Page sectionRightContent={null}>
			{busy && <Spinner />}
			<Error error={groupReq?.error} />
			{merchant && (
				<VBox sx={{ minHeight: "0px", flexGrow: 1 }}>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						{/* <TabItem title="Overview">{<ClientGroupPageOverview clientGroup={merchant} />}</TabItem> */}

						<TabItem title={msg("channels")} icon={<TabIconNetwork size={16} />}>
							<MerchantChannels
								// clientId={groupReq.data.client_id}
								merchantId={merchant.id}
								clientId={clientId}
								readOnly={!canManageMerchant}
							/>
						</TabItem>

						{/* <TabItem title="Terminals">
							<MerchantTerminals clientId={clientId} merchantId={merchant.id} />
						</TabItem> */}

						<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
							<Sessions target_id={merchant.id} target_type="merchant" />
						</TabItem>

						<TabItem title={msg("chargebacks_655ad8a5")} icon={<Undo2 size={16} />}>
							<ClientChargebacks key={`chargebacks-${merchant.id}`} merchantID={merchant.id} merchantName={merchant.name} />
						</TabItem>

						<TabItem title={msg("credentials_d48a617c")} icon={<Key size={16} />}>
							<Credentials target_id={merchant?.id} target_type="merchant" />
						</TabItem>

						<TabItem title={msg("settings")} icon={<SettingsIcon size={16} />}>
							<Settings target_id={merchant.id} target_type="merchant"/>
						</TabItem>
					</Tabs>
				</VBox>
			)}
		</Page>
	);
};
